const oppositeArguments: Record<string, string[]> = {
  _gt: ['_lt'],
  _lt: ['_gt'],
  _gte: ['_lte'],
  _lte: ['_gte'],
};

const validCursorKeys = new Set(['_gt', '_gte', '_lt', '_lte']);

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

export default function isCursorArgumentSimilar(
  firstArgs: unknown,
  secondArgs: unknown,
) {
  if (!isRecord(firstArgs) || !isRecord(secondArgs)) {
    return false;
  }

  const firstKeys = Object.keys(firstArgs);
  const secondKeys = Object.keys(secondArgs);

  if (
    firstKeys.length > 0 &&
    secondKeys.length > 0 &&
    firstKeys.every((key) => validCursorKeys.has(key)) &&
    secondKeys.every((key) => validCursorKeys.has(key))
  ) {
    return true;
  }

  if (firstKeys.length !== 1 || secondKeys.length !== 1) {
    return false;
  }

  const firstKey = firstKeys[0];
  const secondKey = secondKeys[0];

  return (
    firstKey === secondKey ||
    oppositeArguments[firstKey]?.includes(secondKey) === true
  );
}
